// extracted by mini-css-extract-plugin
module.exports = {"MyPet":"styles_MyPet__2L4rt","MyPet-switches":"styles_MyPet-switches__2lx0E","MyPet-fields":"styles_MyPet-fields__100Ep","MyPet-footer":"styles_MyPet-footer__3OzdW"};